<template>
	<div class="private-order-detail-image" :style="{ top: `${containerTop}px` }">
		<div v-if="!isProductLoading" class="main-picture-wrapper" @click="handleClickImage">
			<img :src="mainImage.url" alt="product-image" class="main-picture" />

			<div v-if="mainImage.type === 'video'" class="video-play">
				<i class="bi bi-play-fill"></i>
			</div>
		</div>
		<div v-else class="main-picture-skeleton skeleton"></div>

		<div v-if="!isProductLoading" class="picture-list-parent">
			<div v-if="showPrev" class="prev-button" @click="handleChangeSelectedImage(-1)">
				<i class="bi bi-chevron-left"></i>
			</div>

			<div ref="pictureListContainer" class="picture-list-container">
				<div
					v-for="(image, index) in images"
					:key="index"
					ref="pictureListItem"
					class="list-picture-wrapper"
					:class="{ active: image.active }"
					@click="handleSelectImage(index)"
				>
					<div v-if="image.type === 'video'" class="video-play">
						<i class="bi bi-play-fill"></i>
					</div>

					<img :src="image.url" alt="product-image-item" class="list-picture-item" />
				</div>
			</div>

			<div v-if="showNext" class="next-button" @click="handleChangeSelectedImage(1)">
				<i class="bi bi-chevron-right"></i>
			</div>
		</div>
		<div v-else class="picture-list-parent-skeleton skeleton"></div>
	</div>
</template>

<script>
export default {
	props: {
		yPos: {
			type: Number,
			default: 0,
		},
		images: {
			type: Array,
			default: () => [],
		},
		activeIndex: {
			type: Number,
			default: 0,
		},
		isProductLoading: {
			type: Boolean,
			required: true,
		},
	},
	computed: {
		containerTop() {
			const marginTop = 24;
			const navHeight = 62.5;
			const baseTop = marginTop + navHeight;
			const maxTop = 126;
			const currentTop = this.yPos + baseTop;
			return currentTop < maxTop ? currentTop : maxTop;
		},
		mainImage() {
			// eslint-disable-next-line arrow-parens
			return this.images.find((item) => item.active === true);
		},
		showPrev() {
			return this.activeIndex !== 0 && this.images.length > 4;
		},
		showNext() {
			return this.activeIndex !== this.images.length - 1 && this.images.length > 4;
		},
	},
	methods: {
		handleChangeSelectedImage(increment) {
			const elementContainer = this.$refs.pictureListContainer;
			const elementImage = this.$refs.pictureListItem[0];
			elementContainer.scrollBy({
				left: (2 + elementImage.offsetWidth) * increment,
				behavior: 'smooth',
			});

			this.$emit('move-image', increment);
		},
		handleSelectImage(selectedIndex) {
			this.$emit('select-image', selectedIndex);
		},
		handleClickImage() {
			this.$emit('click-image', true);
		},
	},
};
</script>

<style scoped lang="scss">
.private-order-detail-image {
	width: 240px;
	min-width: 240px;
	max-width: 240px;
	height: fit-content;
	position: sticky;
	display: flex;
	flex-direction: column;
	gap: 8px;

	@media screen and (min-width: 1280px) {
		width: 348px;
		min-width: 348px;
		max-width: 348px;
	}
}

.main-picture-wrapper {
	width: 100%;
	aspect-ratio: 1;
	cursor: pointer;
	position: relative;

	& > .video-play {
		position: absolute;
		z-index: 1;
		width: 60px;
		height: 60px;
		left: calc(50% - 30px);
		top: calc(50% - 30px);
		border-radius: 100%;
		background-color: #00000068;
		border: 1.5px solid #ffffffcd;
		color: #ffffffcd;
		display: flex;
		align-items: center;
		justify-content: center;
		font-size: 28px;
		padding-top: 1px;
		padding-left: 3px;

		@media screen and (min-width: 1280px) {
			width: 80px;
			height: 80px;
			left: calc(50% - 40px);
			top: calc(50% - 40px);
			border: 2px solid #ffffffcd;
			font-size: 38px;
			padding-top: 2px;
			padding-left: 5px;
		}
	}
}

img.main-picture {
	width: 100%;
	aspect-ratio: 1;
	object-fit: cover;
	border-radius: 8px;
	box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.075);
    border: 0.5px solid #d9dadd75;
}

.main-picture-skeleton {
	width: 100%;
	aspect-ratio: 1;
	border-radius: 8px;
}

.picture-list-parent {
	display: flex;
	flex-direction: row;
	align-items: center;

	& > .prev-button,
	.next-button {
		position: absolute;
		width: 26px;
		height: 26px;
		background-color: rgba(82, 88, 102, 0.94);
		display: flex;
		justify-content: center;
		align-items: center;
		color: #ffffff;
		cursor: pointer;
		z-index: 2;

		@media screen and (min-width: 1280px) {
			width: 34px;
			height: 34px;
		}
	}

	& > .prev-button {
		border-radius: 0 4px 4px 0;
		left: 0;
	}

	& > .next-button {
		border-radius: 4px 0 0 4px;
		right: 0;
	}
}

.picture-list-container {
	width: 100%;
	height: auto;
	display: flex;
	flex-direction: row;
	align-items: center;
	gap: 2px;
	overflow-x: auto;
	scrollbar-width: none;
	white-space: nowrap;

	&::-webkit-scrollbar {
		display: none;
	}
}

.list-picture-wrapper {
	flex-shrink: 0;
	width: calc((100% - 8px) / 4);
	border-radius: 10px;
	padding: 3px;
	border: 2.5px solid transparent;
	cursor: pointer;
	position: relative;
	box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.025);
	margin-bottom: 2px;

	& > .video-play {
		position: absolute;
		z-index: 1;
		width: 30px;
		height: 30px;
		left: calc(50% - 15px);
		top: calc(50% - 15px);
		border-radius: 100%;
		background-color: #00000068;
		border: 1.5px solid #ffffffcd;
		color: #ffffffcd;
		display: flex;
		align-items: center;
		justify-content: center;
		font-size: 18px;
		padding-top: 1px;
		padding-left: 2px;

		@media screen and (min-width: 1280px) {
			width: 40px;
			height: 40px;
			left: calc(50% - 20px);
			top: calc(50% - 20px);
			border: 2px solid #ffffffcd;
			font-size: 24px;
		}
	}

	&.active {
		border: 2.5px solid #0063b5;
	}
}

img.list-picture-item {
	width: 100%;
	border-radius: 8px;
	object-fit: cover;
	aspect-ratio: 1;
}

.picture-list-parent-skeleton {
	width: 100%;
	aspect-ratio: 4;
}
</style>
